import { PageHeader } from "components";
import { NextPage } from "next";
import Head from "next/head";
import {
  OrderBannerSection,
  Orders2024Section,
  Orders2026Section,
  PreorderSection,
} from "sections";
import {
  IBuildsFields,
  IPreorderSectionFields,
  IStaticOrderBannerSectionFields,
} from "types";
import { fetchBuildList, getContentfulEntries } from "utils/contentful-api";
import Orders2027Section from "../sections/order/Orders2027Section";
import Orders2028Section from "../sections/order/Orders2028Section";

const Order: NextPage<{
  buildList: IBuildsFields[];
  banner: IStaticOrderBannerSectionFields[];
  preorder: IPreorderSectionFields;
}> = ({ buildList, banner, preorder }) => {
  return (
    <div>
      <Head>
        <title>Order | Jetson - Personal Electric Aerial Vehicle</title>
        <PageHeader
          ogImage="https://www.jetson.com/assets/images/jetson-safety.png"
          title="Order"
        />
        <style>{"html, body { scroll-behavior: smooth; }"}</style>
      </Head>
      <OrderBannerSection bannerSection={banner} />
      <Orders2024Section buildList={buildList} />
      <Orders2026Section buildList={buildList} />
      <Orders2027Section buildList={buildList} />
      <Orders2028Section buildList={buildList} />
      <PreorderSection preorderSection={preorder} />
    </div>
  );
};

export default Order;

export async function getServerSideProps() {
  const banner = await getContentfulEntries<IStaticOrderBannerSectionFields>(
    "orderBannerSection"
  );

  const { buildList } = await fetchBuildList();

  const [preorder] = await getContentfulEntries<IPreorderSectionFields>(
    "preorderSection"
  );

  return {
    props: {
      buildList,
      banner,
      preorder,
    },
  };
}
